var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 24.2093L5.82972 25.0389L10.0915 20.4007L8.46973 26.4718L9.52574 26.7734L12.128 16.9693L5 24.2093Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5703 27.3987L12.7061 27.6934L14.0286 21.5354L15.7083 27.5907L16.7715 27.3155L14.0446 17.5454L11.5703 27.3987Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4149 26.7734L19.5519 26.4837L17.7392 20.4518L22.1321 24.9457L22.9307 24.1919L15.8281 16.949L18.4149 26.7734Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5072 22.918L25.3405 22.092L20.7201 17.811L26.785 19.4586L27.0913 18.4041L17.2969 15.7599L24.5072 22.918Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1749 3.47487L22.3452 2.64529L18.0835 7.2834L19.7052 1.21237L18.6492 0.91071L16.0469 10.7148L23.1749 3.47487Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5996 0.297018L15.4638 0.00238514L14.1414 6.1603L12.4617 0.105079L11.3984 0.3802L14.1254 10.1504L16.5996 0.297018Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6908 16.4297L27.9961 15.2969L21.8498 13.917L27.9216 12.2944L27.6564 11.2288L17.8594 13.8635L27.6908 16.4297Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0805 9.22976L26.7695 8.09854L20.7716 10.0238L25.1831 5.54808L24.4143 4.76391L17.3047 12L27.0805 9.22976Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38494 22.8828L2.55234 22.0561L7.17645 17.779L1.11006 19.4215L0.804688 18.3668L10.6014 15.7309L3.38494 22.8828Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.298621 16.3477L0 15.2131L6.15434 13.8695L0.0923135 12.2111L0.363799 11.1471L10.145 13.8397L0.298621 16.3477Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75805 0.917735L8.62098 1.20747L10.4337 7.23936L6.04077 2.74542L5.24219 3.49924L12.3448 10.7422L9.75805 0.917735Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66223 4.75992L2.82893 5.58591L7.44937 9.86692L1.38441 8.21926L1.07812 9.27378L10.8726 11.918L3.66223 4.75992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/Vision.7b6d94192eb37c474e2832a5761d7004.svg";
export { ForwardRef as ReactComponent };